/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import localStorageService from 'scripts/services/localstorage-service';

const authToken = localStorageService.getItem('access_token');

export default Construct.extend(
    {
        fetch: function(method, params) {
            return new Promise((resolve, reject) => {
                const obj = {
                    method: method,
                    url: '/bin/vc/profile',
                    async: true,
                    crossDomain: true,
                    headers: {
                        Authorization: 'Bearer ' + authToken,
                        'Content-Type': 'application/json',
                        'cache-control': 'no-cache',
                    },
                };
                if (params) {
                    obj.data = JSON.stringify(params);
                }
                can.ajax(obj)
                    .done(function(data) {
                        resolve({ data: data });
                    })
                    .fail(reject);
            });
        },
    },
    {},
);
